import React, { useState, useEffect } from 'react';
import '../Style.css';

const ExitIntentPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phoneNumber: '',
    projectDescription: '',
  });
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setShowPopup(false);
    setStatus('');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateName = (name) => /^[a-zA-Z-' ]{2,}$/.test(name);
  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePhone = (phone) =>
    /^[0-9\s\-\+\(\)]{7,}$/.test(phone);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const fullName = formData.fullName.trim();
    const email = formData.email.trim();
    const phoneNumber = formData.phoneNumber.trim();
    const projectDescription = formData.projectDescription.trim();

    if (!fullName || !email || !phoneNumber) {
      setStatus('Please fill out Full Name, Email, and Phone Number.');
      return;
    }
    if (!validateName(fullName)) {
      setStatus('Full Name must be at least 2 characters and valid.');
      return;
    }
    if (!validateEmail(email)) {
      setStatus('Please enter a valid email address.');
      return;
    }
    if (!validatePhone(phoneNumber)) {
      setStatus('Please enter a valid phone number.');
      return;
    }

    setStatus('');
    setIsSubmitting(true);

    try {
      const response = await fetch('https://www.hatchcoders.com/send-popup.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          fullName,
          email,
          phoneNumber,
          projectDescription,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        setStatus('Form submitted successfully!');
        setFormData({
          fullName: '',
          email: '',
          phoneNumber: '',
          projectDescription: '',
        });
      } else {
        const errors = result.errors ? Object.values(result.errors).join(' ') : result.message;
        setStatus(errors || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      setStatus('Something went wrong. Please try again.');
    }

    setIsSubmitting(false);
  };

  if (!showPopup) return null;

  return (
    <div className="popup-overlay" role="dialog" aria-modal="true" aria-labelledby="popup-title">
      <div className="popup">
        <button id="close1" className="close-btn2" aria-label="Close popup" onClick={handleClose}>
          <img src="../Images/close-white.svg" alt="" />
        </button>
        <div className="popup-content">
          <div className="popup-left">
            <h2 id="popup-title">
              <span role="img" aria-label="waving hand">👋</span>
              <br /> Wait! Before You Go...
            </h2>
            <p>Let our experts provide you—for FREE—with a personalized:</p>
            <ul>
              <li><img src="/Images/check-white.svg" alt="Check icon" /> Tailored Development Plan</li>
              <li><img src="/Images/check-white.svg" alt="Check icon" /> Accurate Budget Breakdown</li>
              <li><img src="/Images/check-white.svg" alt="Check icon" /> Realistic Delivery Timeline</li>
            </ul>
          </div>
          <div className="popup-right">
            <form onSubmit={handleSubmit} noValidate>
              <input
                type="text"
                name="fullName"
                placeholder="Full Name"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Business Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                type="phone"
                name="phoneNumber"
                placeholder="Phone Number"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
              />
              <textarea
                name="projectDescription"
                placeholder="Describe Your Project/Idea in Brief"
                value={formData.projectDescription}
                onChange={handleChange}
              />
              <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
              {status && (
                <p
                  className={`status-message ${
                    status.startsWith('Form submitted') ? 'success' : 'error'
                  }`}
                  role="alert"
                >
                  {status}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExitIntentPopup;
